<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div style="overflow: auto; height: min-content; width: 50rem; padding: 2rem;" class="jm" @click.stop>
            <div style="text-align: center; width: 100%;">
                <h2>Deseja excluir {{ planoNome }}?</h2>
                <br>
                <div class="modal-footer">
                    <button type="button" class="button" @click="$emit('confirmar')">Confirmar</button>
                    <button type="button" class="button acao-secundaria" @click="$emit('fechar')"
                        style="margin-left: 0.5rem;">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalExcluirPlanoPAP",
    props: {
        mostrar: { type: Boolean, default: false },
        planoNome: { type: String, default: "" },
    },
    emits: ["fechar", "confirmar"],
};
</script>
